define('ResetPassword.Main', [
    'ResetPassword.View'
], function (
    ResetPasswordView
) {
    'use strict';
    
    return {
        mountToApp: function mountToApp(container) {
            var pageType = container.getComponent('PageType');

            pageType.registerPageType({
                name: 'reset_password',
                routes: ['reset-password'],
                view: ResetPasswordView,
                options: {
                    container: container
                },
                defaultTemplate: {
                    name: 'resetpassword_edit.tpl',
                    displayName: 'Reset Password'
                }
            });
        }
    };
});
